export const getNonFinancialLength = data =>
  data.map(savingsGroup => savingsGroup.non_savings_types).flat(1).length;

